import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
function Items({ currentItems, lang }) {
  return (
    <>
      {
        currentItems && currentItems.map((item, index) => {
          let text = item.content.replace(/(<([^>]+)>)/gi, "")
          text = text.replace(/&nbsp;/gi, " ")
          text = text.replace(/&amp;/gi, "&").substring(1, 100)
          return (
            <div className="result-item" key={'item-' + index}>
              <img
                src={item.image.length ? item.image : "/themes/custom/dsj/images/esj1.png"}
                alt={item.name}/>
              <h6>{item.title}</h6>
              <span dangerouslySetInnerHTML={{ __html: text }}></span>
              { text.length > 98 ? "..." : null }
              { item.phone.length > 6 ?
                <a className="phone-link" href={'tel:'+item.phone}>{item.phone}</a>:null
              }
              { item.website.length > 5 ?
                <a className="web-link" target="_blank" rel="noopener noreferrer" href={item.website}>Website</a>:null
              }
              <br />
              <a className="webform-button--submit button w-button button button--primary js-form-submit form-submit"
                 href={item.url} target="_blank">{lang === 'fr' ? 'En savoir plus':'More'}</a>
            </div>
          )
        })
      }
    </>
  );
}

function PaginatedItems({ itemsPerPage, members, lang }) {
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [cache, setCache] = useState(members);

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = members.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(members.length / itemsPerPage);

  if(cache.length !== members.length) {
    setCache(members);
    setItemOffset(0);
  }

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % members.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <div className="flex flex-wrap">
        <Items currentItems={currentItems} lang={lang} />
      </div>
      {
        pageCount > 1 ?
        <div className="trip-pagination">
          <ReactPaginate
            breakLabel="..."
            nextLabel={lang === 'fr' ? "suivant >":"next >"}
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel={lang === 'fr' ? "< précédent":"< previous"}
            renderOnZeroPageCount={false}
          />
        </div>:null
      }
    </>
  );
}

export default PaginatedItems;
